/*
 * Copyright ish group pty ltd. All rights reserved. https://www.ish.com.au
 * No copying or use of this code is allowed without permission in writing from ish.
 */

export const ATTR_DATA_PROP_PREFIX = 'data-prop-';
export const ATTR_DATA_CID = 'data-cid';